// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1o8l{display:inline-block}
._4t3i1tcg{height:24px}
._4t3igktf{height:20px}
._4t3izwfg{height:2pc}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/temp-nav-app-icons/dist/esm/utils/icon-wrapper.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB;AAC/B,WAAW,WAAW;AACtB,WAAW,WAAW;AACtB,WAAW,UAAU","sourcesContent":["._1e0c1o8l{display:inline-block}\n._4t3i1tcg{height:24px}\n._4t3igktf{height:20px}\n._4t3izwfg{height:2pc}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
